import axios from 'axios';
import {webfulTrack} from '../app/utils/webful';
import queryString from 'query-string';
import store from '../store';
import {API_ROOT} from '../app/utils';
import {flash, getSharingDetailsPopup} from './sharingDetailsActions';
import {setActiveLabel} from './profileActions'
import {
	findLabels,
	refreshLabels,
	labelStateUpdating,
	resetStates
} from './contactsGroupItemActions';
import {gmailAddOnMsgBar} from './msgBarActions';
import {dropDownPosition, translate} from '../app/utils';
import {findDirectoryGroups, isDirectorySyncRunning} from './directoryGroupActions';
import {findContactDetails, resetFindContactDetails} from "./contactDetailsActions";
import {isFreeEditionLabelContactLimitReachedPopupShown, isUpgradeToBusinessPopup} from './popupActions';

export function findMyContacts(pageSize) {

    return function (dispatch, getState) {

	    let request = '';

	    if (pageSize) {
	    	request = API_ROOT + '/api/labels/6/contacts?pageSize=' + pageSize + '&page=' + store.getState().contactReducer.myContactsPageNumber + '&ownerId=' + getState().profileReducer.getProfile.id;
	    } else {
	    	request = API_ROOT + '/api/labels/6/contacts?page=' + store.getState().contactReducer.myContactsPageNumber + '&ownerId=' + getState().profileReducer.getProfile.id;
	    }

        axios.get(request, {withCredentials: true}).then( response => {
            dispatch({
                type: "FIND_MY_CONTACTS",
                payload: response.data
            });

	        if(response.data.pages.totalPages > 1){
		        dispatch(findNextMyContacts(getState().profileReducer.getProfile.id, pageSize, getState().contactReducer.contactsPageNumber + 1))
	        }
        })
    }

}

export function findNextMyContacts (ownerId, pageSize, pageNumber) {

	return function(dispatch, getState){

		if (getState().contactReducer.findMyContacts !== null) {

			let request = '';

			if (pageSize) {
				if(pageNumber){
					request = API_ROOT + '/api/labels/6/contacts?pageSize=' + pageSize + '&page=' + pageNumber + '&ownerId=' + ownerId;
				} else {
					request = API_ROOT + '/api/labels/6/contacts?pageSize=' + pageSize + '&ownerId=' + ownerId;
				}

			} else {
				if(pageNumber) {
					request = API_ROOT + '/api/labels/6/contacts?page=' + pageNumber + '&ownerId=' + ownerId;
				} else {
					request = API_ROOT + '/api/labels/6/contacts?ownerId=' + ownerId;
				}
			}

			axios.get(request, {withCredentials: true}).then( response => {

				dispatch({
					type: "FIND_NEXT_MY_CONTACTS",
					payload: response.data
				});

				let callNextContacts = setTimeout(() => {

					if(response.data.pages.next !== null && getState().contactReducer.stopFindingNextMyContacts === false){
						if (getState().contactReducer.findContacts !== null) {
							dispatch(findNextMyContacts(ownerId, pageSize, response.data.pages.next))
						}
					} else {
						clearTimeout(callNextContacts);
					}

				}, 1000);

			});
		}

	}

}

export function stopFindingNextMyContacts ( boolean ) {
	return {
		type: 'STOP_FINDING_NEXT_MY_CONTACTS',
		payload: boolean
	}
}

export function myContactsPageSize(int) {
	return {
		type: 'MY_CONTACTS_PAGE_SIZE',
		payload: int
	};
}

export function userContactType(string) {
	return {
		type: 'USER_CONTACT_TYPE',
		payload: string
	}
}

export function myContactsPageNumber(int) {
	return {
		type: 'MY_CONTACTS_PAGE_NUMBER',
		payload: int
	};
}

export function findContacts(groupId, pageSize, pageNumber) {

	return function (dispatch, getState) {

		let request = '';
		let ownerId = getState().contactsGroupItemReducer.getSelectedContactsGroup?.ownerId || getState().profileReducer.getProfile.id;

		if (pageSize) {
			if(pageNumber){
				request = API_ROOT + '/api/labels/' + groupId + '/contacts?pageSize=' + pageSize + '&page=' + pageNumber + '&ownerId=' + ownerId;
			} else {
				request = API_ROOT + '/api/labels/' + groupId + '/contacts?pageSize=' + pageSize + '&ownerId=' + ownerId;
			}

		} else {
			if(pageNumber) {
				request = API_ROOT + '/api/labels/' + groupId + '/contacts?page=' + pageNumber + '&ownerId=' + ownerId;
			} else {
				request = API_ROOT + '/api/labels/' + groupId + '/contacts?ownerId=' + ownerId;
			}
		}

		axios.get(request, {withCredentials: true}).then(response => {

			dispatch(isLoadingContacts(false));

			/*
			* To avoid the previous page loading when scrollTop = 0 when contact list is reloading
			* */

			/*if(document.querySelector(".list-of-contacts-body-content") && store.getState().contactReducer.contactsPageNumber > 1){
				document.querySelector(".list-of-contacts-body-content").scrollTop = 1;
			}*/

			dispatch({
				type: 'FIND_CONTACTS',
				payload: response.data
			});

			if (response.data.message && response.data.message === "Upgrade plan to Business") {
				dispatch(isUpgradeToBusinessPopup(true))
			}

			if(response.data.directorySyncStatus === 'RUNNING'){
				setTimeout(() => {
					if(getState().contactsGroupItemReducer.getSelectedContactsGroup.type === "system"){
						dispatch(findContacts(6, getState().contactReducer.contactsPageSize));
					} else {
						dispatch(findContacts(getState().contactsGroupItemReducer.getSelectedContactsGroup.id, getState().contactReducer.contactsPageSize));
					}

					dispatch(isDirectorySyncRunning(true));
				}, 5000)
			}

			if(getState().directoryGroupReducer.isDirectorySyncRunning) {
				dispatch(findDirectoryGroups()); // true
				dispatch(isDirectorySyncRunning(false));
			}

		})
	}
}

export function findNextContacts (groupId, ownerId, pageSize, pageNumber) {

	return function(dispatch, getState){

		let selectedLabelId = null;

		if(getState().contactsGroupItemReducer.getSelectedContactsGroup){
			if(getState().contactsGroupItemReducer.getSelectedContactsGroup.type === "system"){
				selectedLabelId = '6'
			} else {
				selectedLabelId = getState().contactsGroupItemReducer.getSelectedContactsGroup.id;
			}
		} else {
			selectedLabelId = '6'
		}

		if (selectedLabelId === groupId && getState().contactReducer.findContacts !== null) {

			let request = '';

			if (pageSize) {
				if(pageNumber){
					request = API_ROOT + '/api/labels/' + groupId + '/contacts?pageSize=' + pageSize + '&page=' + pageNumber + '&ownerId=' + ownerId;
				} else {
					request = API_ROOT + '/api/labels/' + groupId + '/contacts?pageSize=' + pageSize + '&ownerId=' + ownerId;
				}

			} else {
				if(pageNumber) {
					request = API_ROOT + '/api/labels/' + groupId + '/contacts?page=' + pageNumber + '&ownerId=' + ownerId;
				} else {
					request = API_ROOT + '/api/labels/' + groupId + '/contacts?ownerId=' + ownerId;
				}
			}

			axios.get(request, {withCredentials: true}).then( response => {

				dispatch({
					type: "FIND_NEXT_CONTACTS",
					payload: response.data
				});

				let callNextContacts = setTimeout(() => {

					if(window.location.pathname.includes("/label/" + groupId) && response.data.pages.next !== null && getState().contactDetailsReducer.findContactDetails === null){
						if (selectedLabelId === groupId && getState().contactReducer.findContacts !== null) {
							dispatch(findNextContacts(groupId, ownerId, pageSize, response.data.pages.next))
						}
					} else {
						clearTimeout(callNextContacts);
					}

				}, 1000);

			});
		}

	}

}

export function isNewContactsLoading (boolean) {
	return {
		type: 'IS_NEW_CONTACTS_LOADING',
		payload: boolean
	}
}

export function contactsPageSize(int) {
	return {
		type: 'CONTACTS_PAGE_SIZE',
		payload: int
	};
}

export function contactsPageNumber(int) {
	return {
		type: 'CONTACTS_PAGE_NUMBER',
		payload: int
	};
}

export function contactsLetter(string) {
	return {
		type: 'CONTACTS_LETTER',
		payload: string
	};
}

// export function findContactDetails(contactId, labelId=''){
//     return function (dispatch) {
//         let userContactType = store.getState().contactReducer.userContactType
//         let ownerId = store.getState().contactsGroupItemReducer.getSelectedContactsGroup.ownerId
//         axios.get(API_ROOT + '/api/contact/' + contactId +'?labelId=' + labelId +'&ownerId=' + ownerId +'&userContactType=' + userContactType, {withCredentials: true}).then( response => {
//            // dispatch(findComments(store.getState().sharingDetailsReducer.getSharingDetailsPopup[2], 50));
//             dispatch({
//                 type: "FIND_CONTACT_DETAILS",
//                 payload: response.data
//             });
//         dispatch({ type: "SEARCH_RESULT",
//             payload: false
//         })})

//     }
// }

export function postCreateContact(object, ownProps) {

	return function (dispatch, getState) {

		let ownerId = getState().contactsGroupItemReducer.getSelectedContactsGroup?.ownerId || getState().profileReducer.getProfile.id;
		let labelId = object.labels[0];
		let checkGmailAddOnTab = getState().profileReducer.setGmailAddOnData;

		/*
		* Gmail Addons
		* */

		if ('checkGmailAddon' in checkGmailAddOnTab && checkGmailAddOnTab?.action !=="createNewContact") {
			ownerId = checkGmailAddOnTab?.ownerId;
			labelId = checkGmailAddOnTab?.labelId;
		}

		axios.post(API_ROOT + '/api/contact/?labelId=' + labelId + '&ownerId=' + ownerId + '&source=WEBAPP', object, {withCredentials: true}).then(() => {
			let queryParameter = queryString.parse(window.location.search);

			/**
			 * if the user is from gmail add on  created a new contact close the window
			 */

			if(getState().sharingDetailsReducer.getSharingDetailsPopup.length > 0 && getState().sharingDetailsReducer.getSharingDetailsPopup[1].includes('gmail')){
				if (queryParameter.action === 'new' || queryParameter.action === 'addToAContact' || queryParameter.action === 'createNewContact' ) {
					window.close();
					dispatch(getSharingDetailsPopup([]));
				}
			}

			dispatch(flash({type: 'success', message: translate('msgBarSuccessText1')}));

			// Webful In-App Analytics
			webfulTrack('contact_created');

			dispatch(findContacts(labelId, getState().contactReducer.contactsPageSize));

			/*
			* Refresh status & labels rendering width delay
			*/

			setTimeout(() => {

				dispatch(refreshLabels());

			}, 2000);

			if(getState().contactsGroupItemReducer.getSelectedContactsGroup){
				if(getState().contactsGroupItemReducer.getSelectedContactsGroup.type === "system"){
					ownProps.history.push('/label/' + getState().contactsGroupItemReducer.getSelectedContactsGroup.id + '-' + getState().contactsGroupItemReducer.getSelectedContactsGroup.ownerId);
				} else {
					ownProps.history.push('/label/' + getState().contactsGroupItemReducer.getSelectedContactsGroup.id);
				}
			} else {
				ownProps.history.push('/label/6-' + ownerId);
			}

		}).catch((e) => {
			let queryParameter = queryString.parse(window.location.search);
			if (queryParameter.action === 'new') {
				window.close();
			}
			dispatch(getSharingDetailsPopup([]));
			if (e.response.data === 'StorageOverQuotaException3 while creating the contact') {
				dispatch(getSharingDetailsPopup([true, 'overQuota']));
			} else if (e.response.data === 'All fields of the contact should not be empty') {
				dispatch(flash({type: 'danger', message: translate("errorEmptyContact")}));
			} else {
				dispatch(flash({type: 'danger', message: translate('msgBarErrorText6')}));
			}

		})
	}

}

export function putUpdateContact(contactId, object, ownerId, ownProps) {

	return function (dispatch , getState) {

		const myObj = getState().contactReducer.contactCardDetails;

		if(Object.keys(myObj).length>1){
			ownerId = getState().contactReducer.contactCardDetails.ownerId;
		}

		let checkGmailAddOnTab = store.getState().profileReducer.setGmailAddOnData;

		let gmailAddOnCheckVariable;

		if ('checkGmailAddon' in checkGmailAddOnTab || checkGmailAddOnTab.action=== "addToAContact") {
			gmailAddOnCheckVariable = true;
			ownerId=''
		} else {
			gmailAddOnCheckVariable = false;
		}

		axios.put(API_ROOT + '/api/contact/' + contactId + '?ownerId=' + ownerId, object, {withCredentials: true}).then( () => {

			// axios.put(API_ROOT + '/mb/contact/' + contactId, object, {withCredentials: true}).then( response => {

			if (gmailAddOnCheckVariable && (checkGmailAddOnTab.action === 'add' || checkGmailAddOnTab.action === 'new' || checkGmailAddOnTab.action === 'view' || checkGmailAddOnTab.action === 'edit' || checkGmailAddOnTab.action === 'viewNotes' || checkGmailAddOnTab.action === 'addNotes'|| checkGmailAddOnTab.action === 'addToAContact')) {
				  window.close()
			}

			dispatch(getSharingDetailsPopup([]));
			dispatch(setDetailsForContactCard({}));
			dispatch(resetFindContactDetails());
			dispatch(contactDetailsEditMode(false));
			dispatch(flash({type: 'success', message: translate('msgBarSuccessText2')}));

			ownProps.history.push('/contact/' + contactId);

		}).catch((e) => {
			if(e.response.data === "Editing of directory v2 contact not allowed when the directory sync type is DIRECTORY LED"){
				dispatch(flash({type: 'danger', message: translate('textErrorDirectoryUpdateContact')}));
			} else {
				dispatch(flash({type: 'danger', message: translate('msgBarErrorText7')}));
			}
			dispatch(getSharingDetailsPopup([]));
		})
	}

}

export function targetedContact(object) {
	return {
		type: 'TARGETED_CONTACT',
		payload: object
	}
}

export function selectedContacts(array) {
	return {
		type: 'SELECTED_CONTACTS',
		payload: array
	}
}

export function contactValue(string) {
	return {
		type: 'USER_TYPE',
		payload: string
	}
}


export function selectedContactFromDrag(array) {
	return {
		type: 'SELECTED_CONTACT_FROM_DRAG',
		payload: array
	}
}

export function labelsOfSelectedContacts(array) {
	return {
		type: 'LABELS_OF_SELECTED_CONTACTS',
		payload: array
	}
}

export function resetContacts() {
	return {
		type: 'FIND_CONTACTS',
		payload: null
	}
}

export function selectLabelToAdd(array) {
	return {
		type: 'SELECT_LABEL_TO_ADD',
		payload: array
	}
}

export function selectContactToAdd(array) {
	return {
		type: 'SELECT_CONTACT_TO_ADD',
		payload: array
	}
}

export function contactSearchResult(string, pageSize) {
	return function (dispatch) {

		axios.get(API_ROOT + '/api/contact/search?q=' + string + '&pageSize=' + pageSize + '&page=' + store.getState().contactReducer.contactSearchResultPageNumber, {withCredentials: true}).then(response => {

			if (store.getState().contactReducer.enteredContactSearchValue === string) {
				dispatch({
					type: 'CONTACTS_SEARCH_RESULT',
					payload: response.data
				});

				if (store.getState().contactReducer.isSearchingContacts) {
					dispatch(isSearchingContacts(false));
				}
			}

		});
	}
}

export function contactSearchResultPageSize(int) {
	return {
		type: 'CONTACTS_SEARCH_RESULT_PAGE_SIZE',
		payload: int
	};
}

export function contactSearchResultPageNumber(number) {
	return {
		type: 'CONTACTS_SEARCH_RESULT_PAGE_NUMBER',
		payload: number
	}
}

export function modalContactSearchResult(string) {
	return function (dispatch, getState) {

		axios.get(API_ROOT + '/api/contact/search?q=' + string, {withCredentials: true}).then(response => {

			if (store.getState().contactReducer.isSearchingContacts) {
				dispatch(isSearchingContacts(false));
			}

			if (getState().contactReducer.enteredModalContactSearchValue === "") {
				dispatch({
					type: 'MODAL_CONTACTS_SEARCH_RESULT',
					payload: {
						contacts : []
					}
				});
			} else {
				dispatch({
					type: 'MODAL_CONTACTS_SEARCH_RESULT',
					payload: response.data
				});
			}

		});
	}
}

export function commentToAddContactSearchResult(string) {
	return function (dispatch, getState) {

		axios.get(API_ROOT + '/api/auto?key=' + string, {withCredentials: true}).then(response => {

			if (getState().contactReducer.isSearchingContacts) {
				dispatch(isSearchingContacts(false));
			}

			dispatch({
				type: 'COMMENT_TO_ADD_CONTACTS_SEARCH_RESULT',
				payload: response.data
			});

			/*
			* Autocomplete reajust on comments creation
			*/

			if (
				document.querySelector('.comments-list-wrapper .new-comment-area')
				&& document.getElementById('writeNewComment')
				&& document.querySelector('.comment-to-add-autocomplete')
			) {
				dropDownPosition(
					document.querySelector('.comments-list-wrapper .new-comment-area'),
					document.getElementById('writeNewComment'),
					document.querySelector('.comment-to-add-autocomplete')
				);
			}

		});
	}
}

export function commentToEditContactSearchResult(string, commentId) {
	return function (dispatch) {

		axios.get(API_ROOT + '/api/auto?key=' + string, {withCredentials: true}).then(response => {

			if (store.getState().contactReducer.isSearchingContacts) {
				dispatch(isSearchingContacts(false));
			}

			dispatch({
				type: 'COMMENT_TO_EDIT_CONTACTS_SEARCH_RESULT',
				payload: response.data
			});

			/*
			* Autocomplete reajust on comments creation
			*/

			if (
				document.querySelector('.comment-contact-details .modal-body')
				&& document.querySelector('.comment-contact-details textarea[data-comment-id="' + commentId + '"]')
				&& document.querySelector('.comment-to-edit-autocomplete')
			) {
				dropDownPosition(
					document.querySelector('.comment-contact-details .modal-body'),
					document.querySelector('.comment-contact-details textarea[data-comment-id="' + commentId + '"]'),
					document.querySelector('.comment-to-edit-autocomplete')
				);
			}

		});
	}
}

export function resetContactSearchResult() {
	return {
		type: 'CONTACTS_SEARCH_RESULT',
		payload: {contacts: []}
	}
}

export function resetModalContactSearchResult() {
	return {
		type: 'MODAL_CONTACTS_SEARCH_RESULT',
		payload: {contacts: []}
	}
}

export function resetCommentToAddContactSearchResult() {
	return {
		type: 'COMMENT_TO_ADD_CONTACTS_SEARCH_RESULT',
		payload: {contacts: []}
	}
}

export function resetCommentToEditContactSearchResult() {
	return {
		type: 'COMMENT_TO_EDIT_CONTACTS_SEARCH_RESULT',
		payload: {contacts: []}
	}
}

export function putLabelToAdd(labels, contactIds, forceLabelSelection, targetLabel, targetContact, directContactShare, finishFirstLabelSharing, ownerId, history) {

	return function (dispatch, getState) {

		// debugger;

		// var result = store.getState().contactsGroupItemReducer.findLabels.contactsGroups.find(obj => {
		//     return obj.id === labelIds[0]
		//   })
		//   let slaveGroupId = result.slaveGroupId
		//   if(slaveGroupId === undefined){
		//     slaveGroupId = ''
		// }

		/**
		 * Getting a variable from the store and checking either its Gmail Add on work
		 */

		let checkGmailAddOnTab = getState().profileReducer.setGmailAddOnData;
		let gmailAddOnCheckVariable;

		if ('checkGmailAddon' in checkGmailAddOnTab) {
			gmailAddOnCheckVariable = true;
		} else {
			gmailAddOnCheckVariable = false;
		}

		let contactId = [];

		contactIds.forEach(obj => {
			let tempobj = {};
			tempobj.id = obj.id;
			tempobj.type = obj.type;
			contactId.push(tempobj)
		});

		let labelToAdd = labels.map(({ id, ownerId }) => ({ labelId: id, ownerId }));

		axios.put(API_ROOT + '/api/v2/contact/membership?source=WEBAPP', {
			'labelIdsToAdd': labelToAdd,
			'contactDataList': contactId
		}, {withCredentials: true}).then(() => {
			// axios.put(API_ROOT + '/mb/v1/label/membership', {
			//     "groupIds": labelIds,
			//     "contactDataList": contactIds
			// }, {withCredentials: true}).then(() => {

			if (gmailAddOnCheckVariable && checkGmailAddOnTab.action === 'add') {
				window.close();
			} else if (gmailAddOnCheckVariable && (checkGmailAddOnTab.action === 'view' || checkGmailAddOnTab.action === 'edit' || checkGmailAddOnTab.action === 'share' || checkGmailAddOnTab.action === 'addNotes' || checkGmailAddOnTab.action === 'viewNotes')) {
				dispatch(setActiveLabel('gmail_add_user'));
				dispatch(getSharingDetailsPopup([]));
				dispatch(setDetailsForContactCard({}));
				let labelStatus = store.getState().contactsGroupItemReducer.findLabels.contactsGroups.find(obj => obj.id === labels[0].id);
				if (labelStatus.permission === 'OWNER' || labelStatus.permission === 'CAN_SHARE') {
					setTimeout(() => {
						dispatch(getSharingDetailsPopup([true, 'gmail_add_user']));
					}, 2000);
				} else {
					window.close();
				}
			}

			if(labels.length > 1){
				dispatch(flash({type: 'success', message: "Contact updated!"}));
			} else {
				if (directContactShare) {
					dispatch(flash({type: 'success', message: translate("msgBarContactAddedToLabelSuccess").replace("{{contact_name}}",targetContact).replace("{{labelName}}",targetLabel)}));
				} else if (store.getState().contactReducer.selectedContacts.length > 0) {
					dispatch(flash({type: 'success', message: translate("msgBarSuccessText5").replace("{{number_of_contacts}}",store.getState().contactReducer.selectedContacts.length).replace("{{labelName}}",targetLabel)}));
				} else if (store.getState().contactReducer.selectContactToAdd.length > 0) {
					dispatch(flash({type: 'success', message: translate("msgBarSuccessText5").replace("{{number_of_contacts}}",store.getState().contactReducer.selectContactToAdd.length).replace("{{labelName}}",targetLabel)}));
				} else if (store.getState().contactReducer.selectedContactFromDrag.length > 0) {
					dispatch(flash({type: 'success', message: translate("msgBarSuccessText5").replace("{{number_of_contacts}}",store.getState().contactReducer.selectedContactFromDrag.length).replace("{{labelName}}",targetLabel)}));
				} else {
					dispatch(flash({type: 'success', message: translate("msgBarSuccessText5").replace("{{number_of_contacts}}",1).replace("{{labelName}}",targetLabel)}));
				}
			}

			if (store.getState().sharingDetailsReducer.getSharingDetailsPopup.length > 0) {
				dispatch(getSharingDetailsPopup([]));
				dispatch(setDetailsForContactCard({}));
			}


			/*
			* For new label created on contact attachment, created label needs to be selected after the user click on Add to label, not just after the label creation.
			* In order to avoid to change the current selected label filtered by the labels list on "Select one label" popup.
			* */

			if (forceLabelSelection) {
				/*dispatch(getSelectedContactsGroup({
					id: forceLabelSelection[0].id,
					name: forceLabelSelection[0].name,
					status: forceLabelSelection[0].status,
					permission: forceLabelSelection[0].permission
				}));*/

				if(getState().contactsGroupItemReducer.getSelectedContactsGroup){
					if(getState().contactsGroupItemReducer.getSelectedContactsGroup.type === "system"){
						history.push('/label/' + forceLabelSelection[0].id + '-' + forceLabelSelection[0].ownerId);
					} else {
						history.push('/label/' + forceLabelSelection[0].id);
					}
				} else {
					history.push('/label/6-' + ownerId);
				}
			}

			/**
			 * If user is not invited so dispatching a action after a successful response so that new action can be dispatched for sharing
			 * whose check is being given in the share indiviual contact
			 */


			if (
				gmailAddOnCheckVariable &&
				store.getState().profileReducer.setGmailAddOnData &&
				store.getState().profileReducer.setGmailAddOnData.plan !==
				'INVITED' &&
				forceLabelSelection
			) {
				dispatch({type: 'GMAIL_ADD_ON_SHARE_CONTACT'});
			}
			/*
			* The user is invited to share this label if this one is not shared
			* */

			else if (
				store.getState().profileReducer.getProfile
				&& store.getState().profileReducer.getProfile.domain
				&& store.getState().profileReducer.getProfile.domain.plan !== 'INVITED'
				&& forceLabelSelection
			) {
				if (store.getState().contactsGroupItemReducer.getSelectedContactsGroup.permission === 'OWNER'
					|| store.getState().contactsGroupItemReducer.getSelectedContactsGroup.permission === 'CAN_SHARE') {
					setTimeout(() => {
						dispatch(getSharingDetailsPopup([true, 'add_user']));
					}, 2000);
				}
			}

			/*
			* Finish the first label share
			* */


			if (finishFirstLabelSharing && gmailAddOnCheckVariable) {
				setTimeout(() => {
					dispatch(
						getSharingDetailsPopup([true, 'gmail_finish_first_label_sharing'])
					);
				}, 2000);

			}

			else if (finishFirstLabelSharing) {
				setTimeout(() => {
					dispatch(getSharingDetailsPopup([true, 'finish_first_label_sharing']));
				}, 2000);
			}

			/*
			* Refresh status & labels rendering width delay
			*/

			setTimeout(() => {

				dispatch(refreshLabels());

			}, 2000);

		}).catch((e) => {
			if (e.response.data.code === 403) {

				if (store.getState().sharingDetailsReducer.getSharingDetailsPopup.length > 0 && !gmailAddOnCheckVariable) {
					dispatch(getSharingDetailsPopup([]));
					dispatch(setDetailsForContactCard({}));
				}

				switch (e.response.data.message) {
					case 'SAME_CONTACT_GROUP':
						dispatch(flash({type: 'danger', message: translate('popupSharingErrorOfSameLabel')}));
						setTimeout(() => {
							dispatch(flash(null));
						}, 4000);
						if (gmailAddOnCheckVariable) {
							dispatch(gmailAddOnMsgBar(['error', translate('popupSharingErrorOfSameLabel')]));
							setTimeout(() => {
								dispatch(gmailAddOnMsgBar([]));
							}, 3000)
						}
						break;
					case 'CANNOT_DRAG_AND_DROP_READ_ONLY_CONTACT':
						dispatch(flash({type: 'danger', message: translate('textErrorReadOnlyList')}));
						break;
					case 'FREE_EDITION_NO_OF_CONTACT_LIMIT_REACHED':
						dispatch(isFreeEditionLabelContactLimitReachedPopupShown(true));
						break;
					default:
						if (store.getState().profileReducer.getProfile.domain.status === 'EXPIRED_EVAL' && gmailAddOnCheckVariable) {
							dispatch(getSharingDetailsPopup([true, 'expired_eval']));
						} else {
							dispatch(getSharingDetailsPopup([true, e.response.data.message]));
						}
				}
			} else {
				dispatch(flash({type: 'danger', message: translate('msgBarErrorText8')}));
				console.error(e);
				dispatch(getSharingDetailsPopup([]));
				dispatch(setDetailsForContactCard({}));
			}

		}).finally(() => {

			dispatch(labelStateUpdating(null));

			if (store.getState().contactReducer.enteredContactSearchValue === '' || store.getState().contactReducer.contactsLetter !== '') {
				dispatch(resetStates('exceptContacts', gmailAddOnCheckVariable));
			} else {
				/*
				* Reload the contact to remove the search result
				**/

				dispatch(resetStates());

				/*console.log(store.getState().contactsGroupItemReducer.getSelectedContactsGroup);
				debugger;*/
			}

			//dispatch(getSharingDetailsPopup([]));

			if ('checkGmailAddon' in checkGmailAddOnTab === false) {
				axios.get(API_ROOT + '/api/group/refresh', {withCredentials: true}).then(() => {
					if (store.getState().contactsGroupItemReducer.getEnteredSearchValue !== '') {
						dispatch(findLabels(false, true));
					} else {
						dispatch(findLabels(store.getState().contactsGroupItemReducer.labelsPageSize, true));
					}
				});
			}

			/*
			* Update the contacts list, both labels and system Contact (for instance in case the user attach a label to a contact)
			* */

			/*dispatch(findMyContacts(store.getState().contactReducer.contactsPageSize));

			if(store.getState().contactReducer.contactsLetter === ""){
				dispatch(findContacts(store.getState().contactsGroupItemReducer.getSelectedContactsGroup.id, store.getState().contactReducer.contactsPageSize));
			} else {
				console.log(store.getState().contactReducer.contactsLetter);
				debugger;
				dispatch(findContacts(store.getState().contactsGroupItemReducer.getSelectedContactsGroup.id, store.getState().contactReducer.contactsPageSize, store.getState().contactReducer.contactsLetter));
			}*/


		})
	}
}

export function putLabelToRemove(contactIds, labelTargetId) {

	let slaveGroupId = store.getState().contactsGroupItemReducer.getSelectedContactsGroup?.slaveGroupId;

	if (slaveGroupId === undefined) {
		slaveGroupId = ''
	}

	let contactId = [];

	contactIds.forEach(obj => {
		let tempobj = {};
		tempobj.id = obj.id;
		tempobj.type = obj.type;
		contactId.push(tempobj)
	});

	let ownerId = store.getState().contactsGroupItemReducer.getSelectedContactsGroup.ownerId;

	return function (dispatch) {

		axios.put(API_ROOT + '/api/v2/contact/membership?source=WEBAPP', {
			contactDataList: contactId,
			labelIdsToRemove: [{ownerId: ownerId, labelId: labelTargetId[0]}]
		}, {withCredentials: true}).then(() => {

			let labelName = store.getState().contactsGroupItemReducer.getSelectedContactsGroup.name
			dispatch(flash({type: 'success', message: translate("msgBarErrorText9").replace("{{labelName}}",labelName)}));

			/*
			* Refresh status & labels rendering width delay
			*/

			setTimeout(() => {

				dispatch(refreshLabels());

			}, 2000);

		}).catch((e) => {

			dispatch(flash({type: 'danger', message: translate('msgBarErrorText8')}));
			console.error(e);

		}).finally(() => {

			dispatch(labelStateUpdating(null));

			dispatch(resetStates('exceptContacts'));

			if (store.getState().contactReducer.selectLabelToAdd.length > 0) {
				dispatch(selectLabelToAdd([]))
			}

			if (store.getState().contactReducer.selectContactToAdd.length > 0) {
				dispatch(selectContactToAdd([]))
			}

			dispatch(getSharingDetailsPopup([]));
			dispatch(setDetailsForContactCard({}));

			axios.get(API_ROOT + '/api/group/refresh', {withCredentials: true}).then(() => {
				if (store.getState().contactsGroupItemReducer.getEnteredSearchValue !== '') {
					dispatch(findLabels(false, true));
				} else {
					dispatch(findLabels(store.getState().contactsGroupItemReducer.labelsPageSize, true));
				}
			});

			/*
			* Update the contacts list, both labels and system Contact (for instance in case the user attach a label to a contact)
			* */

			/*dispatch(findMyContacts(store.getState().contactReducer.contactsPageSize));
			dispatch(findContacts(store.getState().contactsGroupItemReducer.getSelectedContactsGroup.id, store.getState().contactReducer.contactsPageSize));*/

		})
	}
}

export function putLabelToRemoveFromContactDetails(ownerId, labelTargetId, labelTargetOwnerId, contactId, contactType) {
	return function (dispatch, getState) {

		axios.put(API_ROOT + '/api/v2/contact/membership?source=WEBAPP', {
			contactDataList: [{
				"id": contactId,
				"type": contactType,
			}],
			labelIdsToRemove: [{
				labelId: labelTargetId,
				ownerId: labelTargetOwnerId
			}]
		},{withCredentials: true}).then(() => {
			let labelName = getState().contactsGroupItemReducer.getSelectedContactsGroup.name
			dispatch(flash({type: 'success', message: translate("msgBarErrorText9").replace("{{labelName}}",labelName)}));

			/*
			* Refresh status & labels rendering width delay
			*/

			setTimeout(() => {
				dispatch(refreshLabels());
			}, 2000);
		}).catch((e) => {

			dispatch(flash({type: 'danger', message: translate('msgBarErrorText8')}));
			console.error(e);

		}).finally(() => {

			dispatch(labelStateUpdating(null));

			dispatch(resetStates());

			/**
			 * Is called to refresh the label lists from Google Contacts
			 * */

			axios.get(API_ROOT + '/api/group/refresh', {withCredentials: true}).then(() => {
				if (getState().contactsGroupItemReducer.getEnteredSearchValue !== '') {
					dispatch(findLabels(false, true));
				} else {
					dispatch(findLabels(getState().contactsGroupItemReducer.labelsPageSize, true));
				}
			});

			dispatch(findContactDetails(contactId, contactType));
		});
	}
}

export function deleteContact(contactIds, labelId, ownProps) {

	return function (dispatch, getState) {

		let ownerId = getState().contactsGroupItemReducer.getSelectedContactsGroup?.ownerId || getState().profileReducer.getProfile.id;

		axios.delete(API_ROOT + '/api/v2/contact/?labelId=' + labelId + '&ownerId=' + ownerId, {
			data: contactIds,
			withCredentials: true
		}).then(() => {

			dispatch(flash({type: 'success', message: translate('msgBarSuccessDeleteText1')}));

			/*
			* Refresh status & labels rendering
			*/

			dispatch(refreshLabels());

			if(getState().contactsGroupItemReducer.getSelectedContactsGroup){
				if(getState().contactsGroupItemReducer.getSelectedContactsGroup.type === "system"){
					ownProps.history.push('/label/' + getState().contactsGroupItemReducer.getSelectedContactsGroup.id + '-' + getState().contactsGroupItemReducer.getSelectedContactsGroup.ownerId);
				} else {
					ownProps.history.push('/label/' + getState().contactsGroupItemReducer.getSelectedContactsGroup.id);
				}
			} else {
				ownProps.history.push('/label/6-' + ownerId);
			}

		}).catch((e) => {

			if (e.response.data === "Deletion of directory v2 contact not allowed"){
				dispatch(flash({type: 'danger', message: translate('textErrorDirectoryDeleteContact')}));
			} else {
				dispatch(flash({type: 'danger', message: translate('textErrorContactDelete')}));
			}

		}).finally(() => {
			dispatch(resetStates('exceptContacts'));

			if (store.getState().contactReducer.selectLabelToAdd.length > 0) {
				dispatch(selectLabelToAdd([]))
			}

			if (store.getState().contactReducer.selectContactToAdd.length > 0) {
				dispatch(selectContactToAdd([]))
			}

			dispatch(getSharingDetailsPopup(false));

			/*(store.getState().contactsGroupItemReducer.getEnteredSearchValue !== "") {
				dispatch(findLabels(false, true));
			} else {
				dispatch(findLabels(store.getState().contactsGroupItemReducer.labelsPageSize, true));
			}*/

			/*
			* Update the contacts list, both labels and system Contact (for instance in case the user attach a label to a contact)
			* */

			/*dispatch(findMyContacts(store.getState().contactReducer.contactsPageSize));
			dispatch(findContacts(store.getState().contactsGroupItemReducer.getSelectedContactsGroup.id, store.getState().contactReducer.contactsPageSize));*/

		})
	}
}

export function keepOnContacts(boolean) {
	return {
		type: 'KEEP_ON_CONTACTS',
		payload: boolean
	}
}

export function enteredContactSearchValue(string) {
	return {
		type: 'ENTERED_CONTACT_SEARCH_VALUE',
		payload: string
	}
}

export function enteredModalContactSearchValue(string) {
	return {
		type: 'ENTERED_MODAL_CONTACT_SEARCH_VALUE',
		payload: string
	}
}

export function isLoadingContacts(boolean) {
	return {
		type: 'IS_LOADING_CONTACTS',
		payload: boolean
	}
}

export function isSearchResultsDropDownShown(boolean) {
	return {
		type: 'IS_SEARCH_RESULTS_DROPDOWN_SHOWN',
		payload: boolean
	}
}

export function isSearchingContacts(boolean) {
	return {
		type: 'IS_SEARCHING_CONTACTS',
		payload: boolean
	}
}

export function confirmContactResearch(boolean) {
	return {
		type: 'CONFIRM_CONTACT_RESEARCH',
		payload: boolean
	}
}

export function contactDetailsEditMode(boolean) {
	return {
		type: 'CONTACT_DETAILS_EDIT_MODE',
		payload: boolean
	}
}

export function extendAddContactBtn(boolean) {
	return {
		type: 'EXTEND_ADD_CONTACT_BTN',
		payload: boolean
	}
}

export function setDetailsForContactCard(object){
	return {
		type: 'CONTACTCARD_DETAILS',
		payload: object
	}
}

export function isContactsAdvancedSearchDropDown (boolean){
	return {
		type: 'IS_CONTACTS_ADVANCED_SEARCH_DROP_DOWN',
		payload: boolean
	}
}

export function contactsAdvancedSearchRequest (object) {
	return {
		type: 'CONTACTS_ADVANCED_SEARCH_REQUEST',
		payload: object
	}
}

export function postContactsAdvancedSearch(object, pageSize) {
	return function (dispatch, getState) {

		axios.post(API_ROOT + '/api/v2/contact/advance-search?page=' + getState().contactReducer.contactSearchResultPageNumber + '&pageSize=' + pageSize, object, {withCredentials: true})
		.then(response => {

			dispatch({
				type: 'CONTACTS_SEARCH_RESULT',
				payload: response.data
			});

			dispatch(contactsAdvancedSearchRequest(object));

			dispatch(confirmContactResearch(true));

			if (getState().contactReducer.isSearchingContacts) {
				dispatch(isSearchingContacts(false));
			}

			if (getState().contactReducer.isContactsAdvancedSearchDropDown) {
				dispatch(isContactsAdvancedSearchDropDown(false))
			}

		})
		.catch(() => console.error("Server error: Unable to find contacts."))
		.finally(() => dispatch(isSearchingContacts(false)));
	}
}

export function isContactsSearchAdvancedMode(boolean) {
	return {
		type: 'IS_CONTACTS_SEARCH_ADVANCED_MODE',
		payload: boolean
	}
}

export function isUpgradeToBusinessShown(boolean) {
	return {
		type: 'IS_UPDATE_TO_BUSINESS_SHOWN',
		payload: boolean
	}
}

export function isUpgradeToBusinessShownAndActivated(boolean) {
	return {
		type: 'IS_UPDATE_TO_BUSINESS_SHOWN_AND_ACTIVATED',
		payload: boolean
	}
}

export function loadNextContacts (boolean) {
	return {
		type: 'LOAD_NEXT_CONTACTS',
		payload: boolean
	}
}
